<template>
    <section>
        <!--工具条-->
        <!--<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
        <el-form ref="form" style="margin:20px;width:80%;min-width:600px;">
            <el-form-item>
                <el-col class="line" :span="1">门店编码</el-col>
                <el-col :span="3">
                    <el-input v-model="shopto"></el-input>
                </el-col>
                <el-col :span="3">
                    <el-select v-model="pushtype" placeholder="请选择下单类型">
                        <el-option v-for="item in pushtypelist"
                                   :key="item.value"
                                   :label="item.name"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-button type="primary" @click="get_zid">查询</el-button>
                <el-button type="primary" @click="pushorder">下单</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table :data="users"
                  highlight-current-row
                  v-loading="listLoading"
                  @current-change="selectCurrentRow"
                  style="width: 100%;">
            <el-table-column type="index" width="80"></el-table-column>
            <el-table-column prop="id" label="ID" width sortable></el-table-column>
            <el-table-column prop="shopto" label="门店编码" width sortable></el-table-column>
            <el-table-column prop="short_storename" label="门店名称" width sortable></el-table-column>
            <el-table-column prop="ShortName" label="产品名称" width sortable></el-table-column>
            <el-table-column prop="product_code" label="产品条码" width sortable></el-table-column>
            <el-table-column prop="boxes_qty" label="下单盒数" width sortable></el-table-column>
            <el-table-column prop="spec" label="下单片数" width sortable></el-table-column>
            <!--<el-table-column prop="CreateBy" label="创建者" width="" sortable>-->
            <!--</el-table-column>-->
            <!--<el-table-column prop="Enabled" label="状态" width="200" sortable>
                      <template slot-scope="scope">
                          <el-tag :type="scope.row.Enabled  ? 'success' : 'danger'"
                                  disable-transitions>{{scope.row.Enabled ? "正常":"禁用"}}</el-tag>
                      </template>
                      </template>
            </el-table-column>-->
            <!--<
            ---->
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
            <el-pagination layout="prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="50"
                           :total="total"
                           style="float:right;"></el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
                <el-form-item label="订单号:" prop="shortpono">
                    <!--<el-input v-model="editForm.shortpono"  auto-complete="off"></el-input>-->
                    <span>{{editForm.shortpono}}</span>
                </el-form-item>
                <el-form-item label="物流单号" prop="logisticsno">
                    <el-input v-model="editForm.logisticsno" auto-complete="off"></el-input>
                </el-form-item>
                <!-- <el-form-item label="物流公司" prop="logisticscompany">
                  <el-select v-model="editForm.logisticscompany" placeholder="请选择角色状态">
                    <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                <div lass="dialog-footer">
                    <el-button @click.native="editFormVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
                </div>
                <el-table :data="editTable">
                    <el-table-column prop="ShortName" label="产品名称" width sortable></el-table-column>
                    <el-table-column prop="cou" label="订单数量(盒)" width sortable></el-table-column>
                    <el-table-column prop="cou" label="实际发货数量(盒)" width sortable></el-table-column>
                </el-table>
            </el-form>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增"
                   :visible.sync="addFormVisible"
                   v-model="addFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-form-item label="角色名" prop="Name">
                    <el-input v-model="addForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="Enabled">
                    <el-select v-model="addForm.Enabled" placeholder="请选择角色状态">
                        <el-option label="激活" value="true"></el-option>
                        <el-option label="禁用" value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="说明" prop="Description">
                    <el-input v-model="addForm.Description" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import util from "../../../util/date";
    import { dx_zid, removeRole, editRole, addRole } from "../../api/api";
    import { dx_push_order } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    import Toolbar from "../../components/Toolbar";

    export default {
        components: { Toolbar },
        data() {
            return {
                filters: {
                    name: ""
                },
                dateVals: "",
                shopto: "",
                buttonList: [],
                users: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [], //列表选中列
                currentRow: null,
                addDialogFormVisible: false,
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                pushtype:"",
                pushtypelist: [
                    { name: "每周补货", value: "0" },
                    { name: "活动/新开铺货", value: "1" },
                    { name: "全部下单", value: "2" },
                    { name: "活动单独下单(不计入库存)", value: "3" }
                ],
                editFormRules: {
                    logisticsno: [
                        { required: true, message: "请输入物流单号", trigger: "blur" }
                    ],
                    logisticscompany: [
                        { required: true, message: "请选择物流公司", trigger: "blur" }
                    ]
                },
                //编辑界面数据
                editForm: {
                    Id: 0,
                    CreateBy: "",
                    no: "",
                    company: false
                },
                editTable: [],

                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                addFormRules: {
                    Name: [{ required: true, message: "请输入角色名", trigger: "blur" }],
                    Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }]
                },
                //新增界面数据
                addForm: {
                    CreateBy: "",
                    CreateId: "",
                    Name: "",
                    company: ""
                }
            };
        },
        methods: {
            selectCurrentRow(val) {
                this.currentRow = val;
            },
            get_zid(val) {
                var seach = "1";
                this.getRoles(seach);
            },

            starttimeDefault() {
                var date = new Date();
                var s1 =
                    date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
                return s1;
            },
            endtimeDefault() {
                var date = new Date();
                var s1 =
                    date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
                return s1;
            },
            //性别显示转换
            formatEnabled: function (row, column) {
                return row.Enabled ? "正常" : "未知";
            },
            formatTime: function (row, column) {
                if (column.property == "ordertime")
                    return !row.ordertime ||
                        row.ordertime == "" ||
                        row.ordertime == "0000-00-00 00:00:00"
                        ? ""
                        : util.formatDate.format(new Date(row.ordertime), "yyyy-MM-dd");
                if (column.property == "logisticstime")
                    return !row.logisticstime ||
                        row.logisticstime == "" ||
                        row.logisticstime == "0000-00-00 00:00:00"
                        ? ""
                        : util.formatDate.format(new Date(row.logisticstime), "yyyy-MM-dd");
            },

            handleCurrentChange(val) {
                this.page = val;
                this.getRoles("");
            },
            //获取试戴需下单列表
            getRoles(seach) {
                var nPage = this.page;
                if (seach == "1")
                {
                    nPage = 0;
                }
                let _this = this;
                let para = {
                    page: nPage,
                    shopto: this.shopto,
                    pushtype: this.pushtype
                };
                this.listLoading = true;
                //NProgress.start();
                dx_zid(para).then(res => {
                    this.total = res.data.response.dataCount;
                    this.users = res.data.response.data;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            //下单
            pushorder() {
                this.$confirm("确认提交吗？", "提示", {}).then(() => {
                    let para = {
                        pushtype: this.pushtype
                    };
                    //NProgress.start();
                    dx_push_order(para).then(res => {
                        this.total = res.data.response.dataCount;
                        this.users = res.data.response.data;
                        this.listLoading = false;
                        //NProgress.done();
                    });
                });
            },

            //删除
            handleDel() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error"
                    });

                    return;
                }
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        this.listLoading = true;
                        //NProgress.start();
                        let para = { id: row.Id };
                        removeRole(para).then(res => {
                            if (util.isEmt.format(res)) {
                                this.listLoading = false;
                                return;
                            }
                            this.listLoading = false;
                            //NProgress.done();
                            if (res.data.success) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error"
                                });
                            }

                            this.getRoles("");
                        });
                    })
                    .catch(() => { });
            },
            //显示编辑界面
            handleEdit(row, column) {
                //let row = this.currentRow;
                this.editFormVisible = true;
                this.editForm = Object.assign({}, column);

                //let _this2 = this;
                let para = {
                    order_id: column.order_id
                };
                this.listLoading = true;

                //NProgress.start();
                dx_OrderDetail(para).then(res => {
                    this.editTable = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });

                //this.editTable=
            },
            //显示新增界面
            handleAdd() {
                this.addFormVisible = true;
                this.addForm = {
                    CreateBy: "",
                    Name: "",
                    Enabled: ""
                };
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.editLoading = true;
                        //NProgress.start();
                        let para = Object.assign({}, this.editForm);
                        console.log(para);

                        let para_write = {
                            order_id: para.order_id,
                            tracking_no: para.logisticsno,
                            express_company: para.logisticscompany
                        };

                        dx_WriteLogistics(para_write).then(res => {
                            if (res) {
                                this.editLoading = false;
                                //NProgress.done();
                                this.$message({
                                    message: "保存成功",
                                    type: "success"
                                });
                                this.$refs["editForm"].resetFields();
                                this.editFormVisible = false;
                                this.getRoles("");
                            } else {
                                this.$message({
                                    message: "保存失败",
                                    type: "error"
                                });
                            }
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                let _this = this;
                this.$refs.addForm.validate(valid => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.addLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            para.birth =
                                !para.birth || para.birth == ""
                                    ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                                    : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

                            var user = JSON.parse(window.localStorage.user);

                            if (user && user.uID > 0) {
                                para.CreateId = user.uID;
                                para.CreateBy = user.uRealName;
                            } else {
                                this.$message({
                                    message: "用户信息为空，先登录",
                                    type: "error"
                                });
                                _this.$router.replace(
                                    _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                                );
                            }

                            addRole(para).then(res => {
                                if (util.isEmt.format(res)) {
                                    this.addLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.addLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success"
                                    });
                                    this.$refs["addForm"].resetFields();
                                    this.addFormVisible = false;
                                    this.getRoles("");
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error"
                                    });
                                }
                            });
                        });
                    }
                });
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            //批量删除
            batchRemove: function () {
                this.$message({
                    message: "该功能未开放",
                    type: "warning"
                });
            },
            getButtonList2(routers) {
                let _this = this;
                routers.forEach(element => {
                    let path = this.$route.path.toLowerCase();
                    if (element.path && element.path.toLowerCase() == path) {
                        _this.buttonList = element.children;
                        return;
                    } else if (element.children) {
                        _this.getButtonList(element.children);
                    }
                });
            }
        },
        mounted() {
            this.getRoles("");
            this.starttime = this.starttimeDefault();
            this.endtime = this.endtimeDefault();

            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            //第一种写法，每个页面都需要写方法，但是可以做特性化处理
            // this.getButtonList(routers);

            //第二种写法，封装到 permissionRouter.js 中
            this.buttonList = getButtonList(this.$route.path, routers);
        }
    };
</script>

<style scoped>
</style>
